import '../include/allpages'
import '../include/used-rows';
import '../include/loadMore';

$(function () {
    showMoreBrandDesc();
});
function showMoreBrandDesc() {

    $('.model-description-cut').on('click', function() {
        $(this).toggleClass('open');
    });
    
    
    $('.showMore-btn').on('click', function () {
        var parent = $(this).prev();
        if ($(parent).hasClass('closed'))
        {
            $(parent).css('height', $(parent).data('full-height') + 'px');
            $(this).text('Свернуть');
            
        }
        else
        {
            $(parent).css('height', $(parent).data('height') + 'px');
            $(this).text('Еще...');
        }

        $(parent).toggleClass('closed');
        $(parent).toggleClass('open');
    });

}
// todo
// sort models in brand
// function ModelSort () {
//     let items = $('.model-cards .model-card');
//     let arItems = $.makeArray(items);
//     arItems .sort(function(a, b) {
//         return $(a).data("sort") + $(b).data("sort")
//     });
//     $(arItems).appendTo(".model-cards");
// }
// $('.sort-btn').click(function () {
//     ModelSort ();
// });

